
import tccf7Load from './tccf7Load.js';
import tccf7Observation from './tccf7Observation.js';
import tccf7HoneyPot from './tccf7HoneyPot.js';
import tccf7Confirm from './tccf7Confirm.js';
import tccf7Complete from './tccf7Complete.js';

export default class tccf7 {
  constructor( elem ) {
    this.elem   = elem;
    this.id     = elem.id;
    this.form   = elem.querySelector( 'form' );
    this.formId = this.form.getAttribute('id') || null;

    // class
    this.class = {
      none   : 'tccf7_none',
      status : '.wpcf7-confirm-status',
      error  : {
        form    : 'invalid',
        default : 'span.wpcf7-not-valid-tip',
        valid   : 'val-err',
        pot     : 'tccf7-pot-err',
        confirm : 'tccf7-confirm-err',
        inquiry : 'tccf7-inquiry-err',
      },
      step   : {
        stepInput    : 'step-input', 
        stepConfirm  : 'step-confirm',
        stepComplete : 'step-complete',
        stepError    : 'step-error'
      },
      btn    : {
        confirm     : '.wpcf7-confirm',
        back        : '.wpcf7-back',
        send        : '.wpcf7-submit',
        confirmWrap : '.wpcf7-confirm_wrap',
        backWrap    : '.wpcf7-back_wrap',
        all         : '.check_submit'
      }
    }

    // ステータス
    this.status = {
      statusClass : this.class.status,
      statusElem  : elem.querySelector(this.class.status) || null,
      progress    : elem.querySelector(this.class.status)?.getAttribute('value') || 'input',
      oldProgress : 'input',
      value       : false,
      send        : {
        honey     : true,
        confirm   : true,
      }
    };

    // フォーム識別子の取得
    this.prefix           = elem.querySelector('[name="_wpcf7"]')?.value;
    this.jsonConfimrName  = `tccf7_confirm_values_${this.prefix}`;
    this.jsonSendName     = `tccf7_complete_values_${this.prefix}`;
    this.jsonOption       = `tccf7_option_values_${this.prefix}`;
    this.json             = {
      confirm : (typeof window[this.jsonConfimrName] !== 'undefined') ?  window[this.jsonConfimrName] : false,
      send    : (typeof window[this.jsonSendName] !== 'undefined') ? window[this.jsonSendName] : false
    };
    this.option           = {
      scroll  : (typeof window[this.jsonOption] !== 'undefined') ? window[this.jsonOption].scroll : false,
      anime   : (typeof window[this.jsonOption] !== 'undefined') ? window[this.jsonOption].animation : false,
    };

    // 渡す情報まとめ
    this.args = {
      base   : {
        elem   : this.elem,
        form   : this.form,
        error  : 'padding: 5px; color: #D28787; background: #FFE1E1; border-radius: 5px;',
      },
      class  : this.class,
      json   : this.json,
      status : this.status,
      option : this.option,
    }

    this.tccf7ConfirmStart  = false;
    this.tccf7CompleteStart = false;
    this.tccf7HoneyPotStart = false;

    this.init();
  }


  /**
   * 初期化関数
   * 各モジュールの初期化と、状態・イベントのセットアップを行う
   */
  init() {
    this.tccf7Load     = new tccf7Load(this.elem);      // ステップ表示制御
    this.tccf7HoneyPot = new tccf7HoneyPot(this.args);  // スパムチェック用のハニーポット
    this.tccf7Confirm  = new tccf7Confirm(this.args);   // 確認画面の制御
    this.tccf7Complete = new tccf7Complete(this.args);  // 完了画面の制御

    this.setStart();         // 各モジュールの有効/無効状態を取得
    this.setClass();         // 初期クラス付与（ステップ表示など）
    this.setConfirmBase();   // 確認機能が有効な場合の設定
    this.setObserver();      // 入力内容や状態の変更を監視
    this.skipMail();         // メール送信失敗時のフォールバック表示
  }

  /**
   * モジュールのステート（開始状態）をセット
   */
  setStart() {
    this.tccf7ConfirmStart  = this.tccf7Confirm.start;
    this.tccf7CompleteStart = this.tccf7Complete.start;
    this.tccf7HoneyPotStart = this.tccf7HoneyPot.start;
  }

  /**
   * フォームの初期ステップクラスを設定し、全体クラスも付与
   */
  setClass() {
    this.tccf7Load.setStep(this.class.step.stepInput);  // 初期表示は「入力ステップ」
    this.elem.classList.add('tccf7');                   // 全体の識別クラス
  }

  /**
   * 確認画面機能が有効な場合、関連設定を行う
   */
  setConfirmBase() {
    this.tccf7Send = null;
    if (this.tccf7ConfirmStart) {
      this.elem.classList.add('tccf7-confirm-on');              // ステップ形式を有効に
      this.tccf7Confirm.setComplete(this.tccf7CompleteStart);   // 完了処理の有効設定
    }
  }

  /**
   * フォームの内容変更を監視し、状態チェックや更新を自動で行う
   */
  setObserver() {
    const callback = () => {
      this.checkError();      // 入力エラー表示を確認
      this.checkStatus();     // ステータスの進行度を更新
      this.checkSelected();   // select要素の選択値をdata属性に保持
      this.update();          // ステップ表示を更新

      // ハニーポットチェックの結果をステータスに反映
      if (this.tccf7HoneyPotStart) {
        this.status.send.honey = this.tccf7HoneyPot.sendCheck;
      }

      // 確認ステップの状態更新
      if (this.tccf7ConfirmStart) {
        this.tccf7Confirm.update(this.status);
        this.status.send.confirm = this.tccf7Confirm.sendCheck;
      }
    };

    // 監視用モジュールを生成
    new tccf7Observation(this.args.base, callback);
  }

  /**
   * CF7の送信に失敗したときに補足メッセージを表示
   */
  skipMail() {
    document.addEventListener('wpcf7mailsent', (event) => {
      if (event.detail.apiResponse.status === 'validation_failed') {
        const message = document.createElement('p');
        message.textContent = '※メールが送信できませんでした。お手数をおかけして申し訳ございませんが、画面を更新して再度お試しください。';
        this.elem.appendChild(message);
      }
    }, false);
  }

  /**
   * バリデーションエラーがあれば、表示を強調しエラー状態を更新
   */
  checkError() {
    const cf7error = this.form.querySelectorAll(this.class.error.default);
    let check = false;

    if (cf7error) {
      cf7error.forEach(error => {
        if (!error.classList.contains(this.class.error.valid)) {
          check = true;
          error.classList.add(this.class.error.valid);
        }
      });
    }

    if (this.status.progress === 'confirm' && check) {
      this.elem.classList.add(this.class.error.inquiry);  // 確認画面でエラーがある場合
    } else {
      this.elem.classList.remove(this.class.error.inquiry);
    }
  }

  /**
   * select要素の選択値を、data属性に保持（確認画面で使用するため）
   */
  checkSelected() {
    const selects = this.form?.querySelectorAll('select');
    if (selects) {
      selects.forEach(select => {
        const selectedValue = select.value;
        select.setAttribute('data-selected-value', selectedValue);
      });
    }
  }

  /**
   * 現在のフォームステータス（input, confirm, completeなど）を更新
   */
  checkStatus() {
    this.status.statusElem  = this.form.querySelector(this.class.status) || null;
    this.status.oldProgress = this.status.progress;
    this.status.progress    = this.status.statusElem?.getAttribute('value') || 'input';
  }

  /**
   * ステータスの内容に応じて、ステップの表示を更新
   */
  update() {
    if (this.status.progress === 'input') {
      this.tccf7Load.setStep(this.class.step.stepInput);
    } else if (this.status.progress === 'confirm') {
      this.tccf7Load.setStep(this.class.step.stepConfirm);
    } else if (this.status.progress === 'complete') {
      this.tccf7Load.setStep(this.class.step.stepComplete);
    } else if (this.status.progress === 'error') {
      this.tccf7Load.setStep(this.class.step.stepError);
    }
  }

}